import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, Dictionary, EntityState } from '@ngrx/entity';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';
import { WorkedTimesEntity } from '../../entities/worked-times.entity';
import { WorkedTimesActionTypes } from '../actions/worked-times.actions';


export const workedTimesFeatureKey = 'worked-times';

export interface WorkedTimesState extends EntityState<WorkedTimesEntity> {
    fetched: boolean;
    loadedCommissions: Dictionary<{
        lastUpdatedAt: string;
    }>;

    loadedWorkDays: Dictionary<{
        lastUpdatedAt: string;
    }>;
    latestUpdatedAt: Date | null;
}
const adapter = createEntityAdapter<WorkedTimesEntity>({
    selectId: Entity => Entity.Id,
});

const initialConditionsState: WorkedTimesState = adapter.getInitialState({
    fetched: false,
    loadedCommissions: {},
    loadedWorkDays: {},
    latestUpdatedAt: null,
});

export const workedTimesStateReducer = createReducer(
    initialConditionsState,
    on(WorkedTimesActionTypes.UpdateAll, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setAll(Payload, { ...state, fetched: true, latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt }),
    ),
    on(WorkedTimesActionTypes.UpdateMany, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setMany(Payload, {
            ...state,
            latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt,
        }),
    ),
    on(WorkedTimesActionTypes.RemoveMany, (state, { Payload }) =>
        adapter.removeMany(Payload, state),
    ),

    on(WorkedTimesActionTypes.LoadByIdsSuccess, (state, { Payload, commissionIds, workDayIds, serverTimestamp }) =>
        adapter.upsertMany(Payload, {
            ...state,
            loadedCommissions: {
                ...state.loadedCommissions,
                ...commissionIds.reduce((acc, id) => {
                    acc[id] = { lastUpdatedAt: serverTimestamp };
                    return acc;
                }, {} as Dictionary<{ lastUpdatedAt: string }>),
            },
            loadedWorkDays: {
                ...state.loadedWorkDays,
                ...workDayIds.reduce((acc, id) => {
                    acc[id] = { lastUpdatedAt: serverTimestamp };
                    return acc;
                }, {} as Dictionary<{ lastUpdatedAt: string }>),
            },
        }),
    ),
);


/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllWorkedTimes = selectAll;
export const selectWorkedTimesEntities = selectEntities;

export const selectWorkedTimesFetched = (state: WorkedTimesState) => state.fetched;
export const selectWorkedTimesLatestUpdatedAt = (state: WorkedTimesState) => state.latestUpdatedAt;
